import React from 'react';
import { GetStaticProps } from 'next';
import { Typography, Paper, Box } from '@mui/material';
import Image from 'next/image';
import Head from 'src/components/Head';
import Layout from 'src/components/Layout';
import { useI18n } from 'i18n';
import ProductsImage from 'public/images/products.png';

export default function Products(): React.ReactElement {
  const { t } = useI18n();

  return (
    <>
      <Head title={t('product-title')} description={t('product-description')} />
      <Layout>
        <Typography variant="h4" component="h1" sx={{ p: 4, pl: 0 }}>
          {t('products')}
        </Typography>
        <Paper sx={{ mb: 4, p: 2 }}>
          <Typography variant="h5" sx={{ pt: 2, pb: 2 }}>
            {t('energy-simulation')}
          </Typography>
          <Box sx={{ pt: 2, pb: 2 }}>{t('service-description')}</Box>
          <Box sx={{ pt: 2, pb: 2 }}>
            <Image src={ProductsImage} width={975} height={222} alt="service" placeholder="blur" />
          </Box>
        </Paper>
      </Layout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
